import React from 'react';
import { Box, Divider, StatusIndicator, Text, TextButton } from '@wix/design-system';
import { WidgetButton } from '../../../CommonWidgets/shared/WidgetButton/WidgetButton';
import { WidgetLayout } from '../../../CommonWidgets/shared/WidgetLayout/WidgetLayout';
import { useDisabledWidget } from '../../../../shared/disabled-widget/useDisabledWidget';
import { WithDisabledControl } from '../../../../shared/disabled-widget/WithDisabledControl';
import { StyledMarkdownText } from '../../ProactiveMarketingAssistant/common/TextTyper/StyledMarkdownText';
import styles from './TroubleshootWidget.module.scss';
export const TroubleshootWidget = _ref => {
  let {
    data: {
      primaryButton,
      description,
      issues,
      bottomText,
      issueLocationSideEffect
    },
    context,
    config
  } = _ref;
  const {
    emitSideEffect
  } = context;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(TROUBLESHOOT_WIDGET, onWidgetActionData);
    };
    return handler;
  };
  const getExplanation = explanation => {
    return '**Explanation:** ' + explanation;
  };
  const handleLocationSideEffect = location => {
    emitSideEffect(issueLocationSideEffect, location);
  };
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    context: context,
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, description && /*#__PURE__*/React.createElement(StyledMarkdownText, null, description), issues && !!issues.length && /*#__PURE__*/React.createElement("div", {
    className: styles.issuesContainer
  }, issues.map((issue, index) => /*#__PURE__*/React.createElement("div", {
    className: styles.issueContainer
  }, /*#__PURE__*/React.createElement(StatusIndicator, {
    status: "error"
  }), /*#__PURE__*/React.createElement(Box, {
    key: index,
    direction: "vertical",
    gap: "10px",
    marginBottom: "10px"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.issueTitleContainer
  }, /*#__PURE__*/React.createElement(StyledMarkdownText, {
    className: styles.titleContainer
  }, issue.title), issue.location && issue.location.line && (issueLocationSideEffect ? /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    tagName: "span",
    className: styles.issueLocation,
    onClick: () => handleLocationSideEffect(issue.location)
  }, "(Line ", issue.location.line, ")") : /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    tagName: "span",
    className: styles.location
  }, "(Line ", issue.location.line, ")"))), issue.explanation && /*#__PURE__*/React.createElement(Divider, null), issue.explanation && /*#__PURE__*/React.createElement(StyledMarkdownText, {
    className: styles.explanationContainer
  }, getExplanation(issue.explanation)))))), bottomText && /*#__PURE__*/React.createElement(StyledMarkdownText, null, bottomText), (primaryButton == null ? void 0 : primaryButton.label) && /*#__PURE__*/React.createElement(Box, {
    align: "right"
  }, /*#__PURE__*/React.createElement(WithDisabledControl, {
    t: context.t,
    isDisabled: areControlsDisabled,
    onEnable: () => {}
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    context: context,
    webAction: primaryButton.webAction,
    onClick: handleButtonClick('primary_button_click', primaryButton == null ? void 0 : primaryButton.label),
    respondText: primaryButton.respondText,
    icon: primaryButton.icon,
    sideEffect: primaryButton.sideEffect,
    disabled: areControlsDisabled,
    skin: primaryButton.skin
  }, primaryButton.label))));
};
export const TROUBLESHOOT_WIDGET = 'TROUBLESHOOT_WIDGET';
//# sourceMappingURL=TroubleshootWidget.js.map